/**
 * Typography exports.
 *
 * Three `const` font-family objects matching `FoyerLanding.jsx` lines 78–80.
 * Consumers spread them into inline styles or CSS-in-JS, e.g.
 * `style={{ ...mono, fontSize: 12 }}`. The three families are self-hosted
 * (woff2 in `./fonts/`) and loaded via the side-effect CSS import
 * `@sill/ui/css/fonts` (see `src/css/fonts.css`).
 */
export const mono = { fontFamily: "'JetBrains Mono', monospace" };
export const serif = { fontFamily: "'Instrument Serif', serif" };
export const sans = { fontFamily: "'Geist', sans-serif" };
//# sourceMappingURL=fonts.js.map